import { validateContentBlockFormulaExpression } from "@hellocashflow/domain";

import type {
  FormulaValidationError,
  NumberFormatType,
} from "./insertFormulaTypes";

import { getErrorMessage } from "@/utils/errorHandling";

export const mapFormulaValidationMessage = (rawMessage: string): string =>
  getErrorMessage(rawMessage, "Invalid formula.");

export const validateFormula = (
  formula: string,
  numberFormat: NumberFormatType,
): FormulaValidationError | null => {
  const result = validateContentBlockFormulaExpression(formula, numberFormat);
  return result.ok ? null : { error: true, message: result.message };
};
